export default function CertificatePreview({previewRef, name, data}) {
  return (
    <div
      ref={previewRef}
      style={{
        width: "560px",
        height: "434px",
        background: "url('img/kiyg-esports-template-1.jpg') no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        // ...other styles
        position: "relative",
        overflow: "auto",
        fontFamily: "serif",
      }}
    >
      {/* certificate content, font sizes for 560x434 */}
      <h4
                style={{
                  position: "absolute",
                  // top: "52%",
                  top: "51.7%",
                  left: "50%",
                  // top: "218px",
                  // left: "280px",
                  transform: "translate(-50%, -50%)",
                  fontSize: "17px",
                  fontWeight: "bold",
                }}
              >
                {data?.name || name}
              </h4>
              <h6
                style={{
                  position: "absolute",
                  textAlign: "center",
                  top: "61.9%",
                  // top: "262px",
                  left: "62%",
                  // left: "347px",
                  transform: "translate(0, -50%)",
                  fontSize: "9px",
                  fontWeight: "bold",
                }}
              >
                {data?.title||"Battlegrounds Mobile India"}
              </h6>
              <h6
                style={{
                  position: "absolute",
                  textAlign: "center",
                  top: "27.6%",
                //   top: "26.3%",
                  left: "11.3%",
                  transform: "translate(0, -50%)",
                  fontSize: "8.2px",
                  fontWeight: "bold",
                }}
              >
                {data?.referenceNo||"KIYG25/ES/001"}
              </h6>
    </div>
  );
}
